export default __webpack_public_path__ + "static/media/3.a9e554c0.jpg";